module.exports = __webpack_public_path__ + "static/media/CHANGELOG.c90f556a.md";